import {Component, OnInit} from '@angular/core';
import {WebNavigationService} from '../../../navigation.service';
import {ActivatedRoute, Router} from "@angular/router";

@Component({
    selector: 'app-payment-submenu',
    templateUrl: './payment-submenu.component.html',
    styleUrls: ['./payment-submenu.component.scss'],
})
export class PaymentSubmenuComponent implements OnInit {

    constructor(private navigationService: WebNavigationService, private router: Router, private activatedRoute: ActivatedRoute) {
    }

    ngOnInit() {
    }

    selectedPaymentOption(paymentOption) {
        //this.navigationService.selectConciliacionOption(paymentOption);
        if (paymentOption == 0)
            this.router.navigate(['pagosCuentaElectronica'], {relativeTo: this.activatedRoute});
        else if (paymentOption == 1)
            this.router.navigate(['pagosCuentaClabe'], {relativeTo: this.activatedRoute});
    }

    get selectedOption() {
        return this.navigationService.selectedOption;
    }

    get expanded() {
        return this.navigationService.expanded;
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/components/navigation/options/payments/payments-submenu/payment-submenu.component.ts